import React, { useEffect } from "react";
import style from "./downgrade-announcement.module.css";
import StyledButton, { ButtonStyle } from "frontend/ui-components/styled-button";
import CloseIcon from "frontend/ui-components/design-system/icons/close-icon";
import { useSetAtom } from "jotai";
import { userTipsAtom } from "state-atoms";
import { TipName } from "shared/datamodel/schemas/tip";
import tracking from "frontend/tracking";
import { markTipSeen } from "frontend/api";
import { getPathPrefix } from "utils/getPathPrefix";

const BUTTON_SIZE = {
  width: "100%",
  height: 40,
  borderRadius: 8,
  fontFamily: "Poppins",
  fontSize: 14,
  fontWeight: 400,
};

export default function DowngradeAnnouncement({
  onDismiss,
  onUpgrade,
}: {
  onDismiss: () => void;
  onUpgrade: () => void;
}) {
  const setUserTips = useSetAtom(userTipsAtom);

  useEffect(() => {
    tracking.trackAnalyticsEvent("downgrade_notice_viewed");
    markTipSeen(TipName.downgradeNotice);
    setUserTips((previous) => new Set([...previous, TipName.downgradeNotice]));
  }, [setUserTips]);

  return (
    <div className={style.modalContainer}>
      <span
        className={style.closeIcon}
        onClick={() => {
          tracking.trackAnalyticsEvent("downgrade_notice_dismissed");
          onDismiss();
        }}
      >
        <CloseIcon width={15} height={15} />
      </span>
      <div className={style.leftContainer}>
        <img
          className={style.announcementIcon}
          src={getPathPrefix("/images/downgrade-modal-icon.png")}
          alt="downgrade modal icon"
        />
      </div>
      <div className={style.rightContainer}>
        <h2 className={style.title}>You’ve switched to Basic plan</h2>
        <p className={style.subtitle}> Here’s what you get:</p>
        <div className={style.featuresContainer}>
          <div className={style.featureItem}>
            <div className={style.bulletPoint} />
            <p>3 editable canvases (others view-only)</p>
          </div>
          <div className={style.featureItem}>
            <div className={style.bulletPoint} />
            <p>10 collaborators per canvas</p>
          </div>
          <div className={style.featureItem}>
            <div className={style.bulletPoint} />
            <p>Basic templates</p>
          </div>
        </div>
        <p className={style.bottomLineText}>Go Pro anytime to get the most out of WorkCanvas.</p>
        <div className={style.buttonContainer}>
          <StyledButton
            onClick={() => {
              tracking.trackAnalyticsEvent("downgrade_notice_dismissed");
              onDismiss();
            }}
            style={ButtonStyle.outline}
            title="Continue to Free"
            customStyle={{ ...BUTTON_SIZE, color: "#1973FF" }}
          />
          <StyledButton
            onClick={() => {
              tracking.trackAnalyticsEvent("downgrade_notice_upgrade_clicked");
              onUpgrade();
            }}
            title="Upgrade to Pro"
            customStyle={{ ...BUTTON_SIZE, color: "#FFF" }}
          />
        </div>
      </div>
    </div>
  );
}
